module.exports = __webpack_public_path__ + "img/s5.563d0fc2.png";